<template>
  <v-sheet color="white">
    <v-container class="text-center py-12">
        <h1 class="text-h4 text-md-h3">Gestion des cours Moodle</h1>

        <v-card
          max-width="500"
          class="mx-auto mt-6 d-flex justify-space-between"
        >
          <div>
            <v-card-title
              class="text-h6 text-md-h5"
            >
              {{ user.name }}
            </v-card-title>

            <v-card-subtitle class="text-left">{{ user.username }}</v-card-subtitle>

            <v-card-actions>
              <router-link
                v-if="user.groups.includes('ENS')"
                to="teacher"
                class="mx-2"
              >
                Enseignant
              </router-link>

              <router-link
                v-if="user.groups.includes('ETU')"
                to="student"
                class="mx-2"
              >
                Etudiant
              </router-link>
            </v-card-actions>
          </div>

          <v-avatar
            class="ma-3"
            size="102"
            tile
          >
            <v-img :src="require('@/assets/undraw_male_avatar_323b.svg')"></v-img>
          </v-avatar>
        </v-card>
    </v-container>
  </v-sheet>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TheHeader',

  computed: {
    ...mapGetters(['user']),
  },
};
</script>
